import React from "react";
import ContactForm from "./ContactForm";

const ContactMain = () => {
  return (
    <>
      <section className="container mx-auto py-16 px-8 lg:px-16">
        <div className="flex flex-col lg:flex-row items-start gap-16">
          {/* Left Side: Contact Information */}
          <div className="w-full lg:w-1/2 space-y-6">
            <h3 className="text-4xl mt-12 text-primary font-bold relative inline-block">
              Get In
              <span className="absolute bottom-[-8px] left-0 w-12 h-1 bg-secondary"></span>
              <span className="text-secondary"> Touch</span>
            </h3>
            <p className="my-8 mx-auto ">
              We value your inquiries and look forward to assisting you. Please
              feel free to connect with us through any of the following contact
              methods.
            </p>
            <div className="space-y-4">
              <div>
                <h4 className="text-md font-semibold text-gray-800">
                  Address:
                </h4>
                <p className="text-gray-900">
                  Jivan Chaya HSG SOC. PL 21, Kothrud, Pune- 411038,
                  Maharashtra
                </p>
              </div>
              <div>
                <h4 className="text-md font-semibold text-gray-800">Phone:</h4>
                <p className="text-gray-900">
                  <a href="+919730305633" className="hover:text-primary">
                    +91 9730305633
                  </a>
                </p>
              </div>
              <div>
                <h4 className="text-md font-semibold text-gray-800">Email:</h4>
                <p className="text-gray-900">
                  <a
                    href="sales@pixelinnovative.net"
                    className="hover:text-primary"
                  >
                    sales@pixelinnovative.net
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Right Side: Inquiry Form */}
          <div className="w-full lg:w-1/2 p-10 border rounded-md">
            <h3 className="text-2xl font-bold text-primary mb-6">
              Send Us a Message
            </h3>
            <ContactForm />
          </div>
        </div>
      </section>

      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8998.458536876933!2d73.81640441134053!3d18.51146171888456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bfbd8e967991%3A0x773ade07caea7147!2sJeevan%20Chhaya%20Housing%20Cooperative%20Society%2C%20Paud%20Rd%2C%20LIC%20Colony%2C%20Rambaug%20Colony%2C%20Kothrud%2C%20Pune%2C%20Maharashtra%20411038!5e0!3m2!1sen!2sin!4v1741763659789!5m2!1sen!2sin"
          width="100%"
          height="400"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          title="google_map"
        ></iframe>
      </div>
    </>
  );
};

export default ContactMain;
